import React, { FC, useMemo, useState } from 'react';

import FormulaTemplateModal from '../../components/formulas/FormulaTemplateMap/FormulaTemplateModal';
import { SearchableSelectType } from 'components/inputs/searchableSelect';
import GenericSpinner from 'components/nav/GenericSpinner';

import { FormulaType } from '../../constants/formulaType';

import {
    defaultEditorDetails,
    EditorContext,
    EditorDetailsModel,
} from '../../context/EditorContext';

import useQueryFetchTemplates from '../../hooks/EmailTemplate/useQueryFetchTemplates';
import useFormulaQuery from '../../hooks/formulas/useFormulaQuery';

import { FormulaDetailModel } from 'models/formula.model';

interface RelatedMessageRemapModalProps {
    selectedMessages: FormulaDetailModel[];
    handleClose: () => void;
    templateId?: string;
}

const RelatedMessageRemapModal: FC<RelatedMessageRemapModalProps> = ({
    selectedMessages,
    handleClose,
    templateId,
}) => {
    const formulaId = selectedMessages[0]?.id;
    const { data: formula, isLoading: isFormulaLoading } = useFormulaQuery(
        formulaId,
        { enabled: !!formulaId },
    );
    const { data: rawTemplates, isLoading: isTemplatesLoading } =
        useQueryFetchTemplates();

    const [temporaryValue, setTemporaryValue] = useState<
        SearchableSelectType | undefined
    >(undefined);

    const templateOptions = useMemo<SearchableSelectType[]>(
        () =>
            rawTemplates?.map((template) => ({
                label: template.template_name,
                value: template.email_template_id,
            })) ?? [],
        [rawTemplates],
    );

    const isAampeCustomTemplate = !!rawTemplates?.find(
        (t) => t.email_template_id === temporaryValue?.value,
    )?.is_aampe_custom_template;

    const editorDetails = useMemo<EditorDetailsModel>(
        () => ({
            ...defaultEditorDetails,
            formula: formula ?? null,
            formulaType: formula?.message_type ?? FormulaType.email,
        }),
        [formula],
    );

    const editorContextValue = useMemo(
        () => ({
            editorDetails,
            setEditorDetails: () => {},
        }),
        [editorDetails],
    );

    if (isFormulaLoading || isTemplatesLoading) {
        return <GenericSpinner />;
    }

    if (!formula) {
        return null;
    }

    return (
        <EditorContext.Provider value={editorContextValue}>
            <FormulaTemplateModal
                templateOptions={templateOptions}
                handleCancel={handleClose}
                temporaryValue={temporaryValue}
                isAampeCustomEmailTemplate={isAampeCustomTemplate}
                setTemporaryValue={setTemporaryValue}
                selectedMessages={selectedMessages}
                templateId={templateId}
            />
        </EditorContext.Provider>
    );
};

export default RelatedMessageRemapModal;
